/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPlanDetails } from 'services/api/plansApi';
import { TAllPlanState, TPlanList } from 'typings';

export const fetchAllPlans = createAsyncThunk(
  'spaces/fetchAllPlans',
  async (payload: string, thunkAPI) => {
    try {
      const response = await getPlanDetails(payload);
      return response.data;
    } catch {
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialPlanState: TAllPlanState = {
  allPlans: [],
  isLoading: false
};

export const allPlanSlice = createSlice({
  name: 'allPlans',
  initialState: initialPlanState,
  reducers: {
    clearAllPlansData: (state) => {
      state.allPlans = [];
    },
    updateAllPlansData: (state, action) => {
      state.allPlans = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allPlans = action.payload as TPlanList[];
      })
      .addCase(fetchAllPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllPlans.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const { clearAllPlansData, updateAllPlansData } = allPlanSlice.actions;

export default allPlanSlice.reducer;
